









































































































































































































































//@ts-ignore
import NaijaStates from "naija-state-local-government";
// import moment from "moment";
import { db } from "@/firebase/firebase";
import {
  computed,
  defineComponent,
  reactive,
  ref,
  toRefs
} from "@vue/composition-api";
import { countries } from "@/store/hardData";
import { useMainStore } from "@/store/storage";

// import { Client } from "@/interfaces/interfaces";
export default defineComponent({
  name: "clientForm",
  props: {
    activeClient: {
      type: Object,
      default: { id: null }
    }
  },
  setup(props, { root }) {
    const main = useMainStore();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const form: any = ref(null);
    const state = reactive({
      formStatus: false,
      success: false,
      menu2: false
    });

    //     root.$on('clicked',( e: Client )=>{
    //       state.clientData = e;
    // })

    // if (props.activeClient.id) {
    //   state.clientData = {
    //     companyName: props.activeClient.companyName,
    //     addressLine1: props.activeClient.addressLine1,
    //     addressLine2: props.activeClient.addressLine2,
    //     country: props.activeClient.country,
    //     state: props.activeClient.state,
    //     LGA: props.activeClient.LGA,
    //     mobile: props.activeClient.mobile,
    //     email: props.activeClient.email,
    //     policyCode: props.activeClient.policyCode,
    //     policyNumber: props.activeClient.policyNumber
    //   };
    // }

    const NigeriaInfo = reactive({
      NigeriaStates: NaijaStates.states(),
      NigeriaLGA: NaijaStates.lgas(main.state.clientData.state)
    });

    function clearStates() {
      main.state.clientData.state = "";
      main.state.clientData.LGA = "";
      if (main.state.clientData.country === "Nigeria" && main.state.clientData.state)
        NigeriaInfo.NigeriaLGA = NaijaStates.lgas(main.state.clientData.state);
    }
    function clearLGA() {
      // main.state.clientData.LGA = "";
      if (main.state.clientData.country === "Nigeria" && main.state.clientData.state)
        NigeriaInfo.NigeriaLGA = NaijaStates.lgas(main.state.clientData.state);
    }

    function resetClientData() {
      // form.value.reset();
      main.resetClientData();
      form.value.resetValidation();
    }

    interface ClientLabel {
      title: string;
      button: string;
      action: string;
    }

    const clientLabel = computed(() => {
      const newItem = {
        title: "Add New Client",
        button: "Save New Client",
        action: "add"
      };

      const editItem = {
        title: "Edit Client",
        button: "Save Changes",
        action: "update"
      };

      return main.state.clientData.id ? editItem : newItem;
    });

    // const PolicyCode = computed(() => {
    //   const comName = main.state.clientData.companyName;
    //   const policyCode = (
    //     comName.substring(0, 2) + comName.substring(comName.length - 2)
    //   ).toUpperCase();
    //   if (!main.state.clientData.id) {
    //     main.state.clientData.policyCode = policyCode;
    //     return;
    //   }
    // });

    const processForm = () => {

      if (state.formStatus) {

        if (!main.state.clientData.id) {
          db.collection("clients")
            .add(main.state.clientData)
          form.value.resetValidation();
          form.value.reset();
          state.success = true;
        }

        if (main.state.clientData.id) {
          db.collection("clients")
            .doc(main.state.clientData.id)
            .update(main.state.clientData)
          state.success = true;
          // form.value.resetValidation();
          // form.value.reset();
        }
      }
    };

    // async function getPlans() {

    root.$on("showclientform", () => {
      main.resetClientData();
    });

    // }

    return {
      mainStore: main,
      mainState: main.state,
      ...toRefs(state),
      ...toRefs(NigeriaInfo),
      countries,
      clearStates,
      clearLGA,
      resetClientData,
      processForm,
      clientLabel,
      form
    };
  }
});
